import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function DialogComplexQuestion({title, desc, open, onClose }) {

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {desc}
          <div>
          <Button variant="outlined" onClick={()=>onClose("waitlist")} autoFocus>
           Add To Waitlist 
          </Button>
          <Button variant="outlined" onClick={()=>onClose("appointment")} autoFocus>
            Add Appointment
          </Button>
</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>onClose(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
